const menuBtn = () => {
  const menuBtn = $('.top-side-btn--menu'),
        menuCont = $('.top-menu')
  menuBtn.on('click', function(){
    const menuText = $(this).find('.top-side-btn__txt'),
          btnCircle = $(this).find('.c-btn-circle__inner')            
    
    $(this).toggleClass('is-open');
    menuCont.toggleClass('is-open');
    btnCircle.toggleClass('is-open');

    if(menuText.text() === 'MENU') {
      menuText.text('CLOSE')
      const mediaQuery = window.matchMedia('(max-width: 767px)')
      if (mediaQuery.matches) {
        $('html').addClass('is-view-lock')
      }
    } else {
      $('html').removeClass('is-view-lock')
      menuText.text("MENU")
    }
  })
}

const logoApp = () => {
  const logo = $('.top-logo-pc__img'),
        winScroll = $(window).scrollTop(),
        mvHeight = $('.top-mv').height();
  
  const changeLogo = (bfr,aft) => {
    let src = logo.attr('src').replace(bfr,aft);
    logo.attr('src',src);
  } 
    
  if(mvHeight < winScroll) {
    changeLogo('white','black');
  } else {
    changeLogo('black','white');
  }

}

const topMenu = () => {
  menuBtn();
  logoApp();
}



let spotlight = () => {
  const slides =  $('.top-spotlight-list');
  slides.slick({
    centerMode: true,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          centerPadding: '50px',
        }
      },
    ],
  })
}

let pr = () => {
  
  const fixWrapper = $('.top-pr-wrapper'),
        reportWrapper = $('.top-report-wrapper'),
        logo = $('.top-pr__img--front'),
        reportWrapperPos = reportWrapper.offset().top,
        fix = $('.top-sec--pr'),
        pr = $('.top-pr'),
        prBg = $('.top-pr-bg'),
        winH = $(window).height(),
        fixTop = fixWrapper.offset().top,
        winScroll = $(window).scrollTop();

  if(winScroll >= fixTop + 10) {
    fix.addClass('is-fixed');
    prScale();
    console.log('ok if');
  } else {
    fix.removeClass('is-fixed');
    reportWrapper.css('margin-top',0);
    prScale(0);
  }

  if(winScroll + winH + 100 > reportWrapperPos) {
    pr.addClass('is-white');
    logo.addClass('is-none');
  } else {
    pr.removeClass('is-white');
    logo.removeClass('is-none');
  }

  const mediaQuery = window.matchMedia('(max-width: 767px)')
  if (mediaQuery.matches) {
    reportWrapper.css('margin-top', winH*6.5);
  } else {
    reportWrapper.css('margin-top', winH + 2000);
  }

}

let prScale = (none) => {
  const winScroll = $(window).scrollTop(),
        firstPart = $('.top-first-part'),
        firstPartH = firstPart.height(),
        prBg = $('.top-pr-bg'),
        bgSize = (winScroll - firstPartH)/15;
        console.log('ok scale');
  let i = 0;
  
  prBg.css('-webkit-mask-size', bgSize +'%');
  prBg.css('-webkit-mask-size', none);
  
}

let mvLoading = () => {
  const loading = $('.js-top-loading');
  setTimeout(() => {
    loading.addClass('is-loaded');
  },500);
}

let mvScale = (scale) => {
  const fader = $('.top-mv-fader');
        let size = 0;
  
    setTimeout(() => {
      let sizeStep = setInterval(()=>{
        fader.css('-webkit-mask-size', size++ + '%')
        if(400 <= size) {
          clearInterval(sizeStep);
        }
      },scale)
    },1000);
}

let mvSlides = () => {
  const slides = $('.top-mv-fader');
  setTimeout(()=>{
    slides.slick({
      autoplay: true,
      swipe: false,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      fade: true,
      arrows: false,
      autoplaySpeed: 1000,
      speed: 4000
  })
  },3000)
}

let mv = () => {
  const sp = window.matchMedia('(max-width: 767px)').matches;

  mvLoading()
  
  if(sp){
    mvScale(5)
    console.log('sp');
  } else {
    mvScale(10)
    console.log('pc');
  }
  mvSlides()
}

$(()=>{
  topMenu();
  spotlight()
  pr()
});

$(window).on('load',()=>{
  mv();
})

$(window).on('load resize', ()=>{
  
});

$(window).on('load scroll', ()=>{
  logoApp()
  pr()
});